// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6355":"83ab338d","6983":"964bee48","7502":"c6a2fa19"}[chunkId] + ".chunk.css";
};